<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <div v-if="siteOptions" class="site-footer-copyright">
    Copyright © {{ new Date().getFullYear() }} Tous droits réservés {{ siteOptions.name }}
  </div>
</template>
